import 'core-js/es5';
import 'core-js/es7/reflect';

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/fn/object/assign';
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es7/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';

import 'zone.js/dist/zone';

import 'hammerjs/hammer';

// if (process.env.ENV === 'production') {
//   // Production
// } else {
//   // Development and test
//   Error['stackTraceLimit'] = Infinity;
//   require('zone.js/dist/long-stack-trace-zone');
// }


// WEBPACK FOOTER //
// ./app/polyfills.ts